define('widgets/dgrid/utils/DGridBlock',[
    'underscore',
    'knockout'
], function (_, ko) {

    var DGridBlock = function (mainBlock, fallbackBlock, fullWidth) {
        var self = this;

        self.module = mainBlock;
        self.fallback = fallbackBlock ? fallbackBlock.module : null;
        self.fullWidth = fullWidth;
        self.activateFallback = ko.observable(false);
    };

    return DGridBlock;
});


